export class CacheStorageProxy {
  private prefix: string

  constructor(prefix: string) {
    this.prefix = prefix
  }

  private getKey(key: string): string {
    return `${this.prefix}:${key}`
  }

  setItem(key: string, value: any): void {
    localStorage.setItem(this.getKey(key), JSON.stringify(value))
  }

  getItem<T = any>(key: string): T | null {
    const value: string | null = localStorage.getItem(this.getKey(key))
    if (!value) return null

    try {
      return JSON.parse(value) as T
    } catch (error) {
      return null
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(this.getKey(key))
  }

  clear(): void {
    const keys = Object.keys(localStorage)
    keys.forEach((key) => {
      if (key.startsWith(this.prefix + ':')) {
        localStorage.removeItem(key)
      }
    })
  }

  getAllKeys(): string[] {
    return Object.keys(localStorage)
      .filter((key) => key.startsWith(this.prefix + ':'))
      .map((key) => key.slice(this.prefix.length + 1))
  }

  /**
   * 监听缓存变化
   * @param key 缓存key
   * @param callback 回调函数
   * @returns 取消监听函数
   */
  watch(key: string, callback: (value: any) => void) {
    const watchKey = this.getKey(key)
    const handler = (e: StorageEvent) => {
      if (e.key === watchKey) callback(e.newValue)
    }
    window.addEventListener('storage', handler)
    return () => {
      window.removeEventListener('storage', handler)
    }
  }
}

// 缓存实例
export const cacheStore = new CacheStorageProxy('seaart_sdk')
